export enum EApprovalStatus {
	DRAFT = 'DRAFT',
	WAITING_APPROVAL = 'WAITING_APPROVAL',
	APPROVED = 'APPROVED',
	REJECTED = 'REJECTED'
}